(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();
    this.updateHeaderBounds();

    window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
      this.setHeaderHeight();
      this.updateHeaderBounds();
    });

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  updateHeaderBounds() {
    this.headerBounds = this.header.getBoundingClientRect();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver(() => {
      this.updateHeaderBounds();
    });

    observer.observe(this.header);
  }

onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyHeaderType = this.getAttribute('data-sticky-type');
    const scrollThreshold = 10; 

    this.updateHeaderBounds();

    if (scrollTop > this.currentScrollTop + scrollThreshold && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (stickyHeaderType === 'on-scroll-up') {
            this.header.style.transform = 'translateY(-20px)';
        }

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
    } 
    else if (scrollTop < this.currentScrollTop - scrollThreshold) {
        if (stickyHeaderType === 'on-scroll-up') {
            this.header.style.removeProperty('transform');
        }
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
    } 
    else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
}

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["typewriter-text"] && !Shopify.designMode) return;
  try {
    
function initTypewriter(sectionId) {
  const sectionElement = document.querySelector(`.typewriter-text-${sectionId}`);
  if (!sectionElement) return;

  const typewriterElement = sectionElement.querySelector('.typewriter-word');
  const wordsContainer = sectionElement.querySelector('.typewriter-words');

  if (!typewriterElement || !wordsContainer) return;

  const words = Array.from(wordsContainer.children).map(span => ({
    text: span.dataset.word,
    color: span.style.color,
    blockId: span.dataset.blockId, // Capture le block ID
  }));

  if (!words.length) return;

  const typingSpeed = parseInt(sectionElement.dataset.typingSpeed, 10) || 100;
  const wordDisplayTime = parseInt(sectionElement.dataset.wordDisplayTime, 10) || 2000;

  let currentWordIndex = 0;
  let currentCharIndex = 0;
  let isDeleting = false;

  const type = () => {
    const currentWord = words[currentWordIndex];

    if (isDeleting) {
      typewriterElement.textContent = currentWord.text.substring(0, currentCharIndex - 1);
      currentCharIndex--;
    } else {
      typewriterElement.textContent = currentWord.text.substring(0, currentCharIndex + 1);
      currentCharIndex++;
    }

    typewriterElement.style.color = currentWord.color;

  typewriterElement.className = `typewriter-word typewriter-word-${currentWord.blockId}`;

    if (!isDeleting && currentCharIndex === currentWord.text.length) {
      isDeleting = true;
      setTimeout(type, wordDisplayTime);
    } else if (isDeleting && currentCharIndex === 0) {
      isDeleting = false;
      currentWordIndex = (currentWordIndex + 1) % words.length;
      setTimeout(type, typingSpeed);
    } else {
      setTimeout(type, typingSpeed);
    }
  };

  type();
}

function initializeAllTypewriterSections() {
  const sections = document.querySelectorAll('.typewriter-text');
  sections.forEach(section => {
    const sectionId = section.getAttribute('data-section-id');
    if (sectionId) {
      initTypewriter(sectionId);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllTypewriterSections);
} else {
  initializeAllTypewriterSections();
}

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const sectionId = event.target.querySelector('.typewriter-text')?.getAttribute('data-section-id');
    if (sectionId) {
      initTypewriter(sectionId);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-text"] && !Shopify.designMode) return;
  try {
    
function WaveText() {
  const textPath = document.querySelector('#text-path');
  const textContainer = document.querySelector('#text-container');
  const path = document.querySelector(textPath.getAttribute('href'));
  const pathLength = path.getTotalLength();
  let lastOffset = pathLength; 

  function updateTextPathOffset(offset) {
    textPath.setAttribute('startOffset', offset);
  }

  updateTextPathOffset(pathLength);

  function onScroll() {
    requestAnimationFrame(() => {

      const rect = textContainer.getBoundingClientRect();
      const threshold = 0.2;
      const scrollPercent = (rect.y - window.innerHeight * threshold) / window.innerHeight;
      const newOffset = scrollPercent * 1.1 * pathLength;

      if (Math.abs(newOffset - lastOffset) > 1) {
        updateTextPathOffset(newOffset);
        lastOffset = newOffset;
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
}

WaveText();

document.addEventListener("shopify:section:load", (e) => {
  WaveText();
});

  } catch(e) { console.error(e); }
})();
})();
